import type { ReactNode } from 'react'
import React, { useContext as useContextCore } from 'react'

export type ProviderProps = {
  logo: ReactNode
  children: React.ReactNode
}

export type ContextType = Omit<ProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const AccountJoinProvider = ({ children, ...props }: ProviderProps) => {
  return <CoreProvider value={{ ...props }}>{children}</CoreProvider>
}

export const useAccountJoinContext = () => useContextCore(context)
